<script lang="ts">
	//Design system components
	import {
		AdvancedCard,
		AdvancedCardV2,
		Alert,
		LabelList,
		LabelListV2,
	} from '@Shelly/shelly-design-system/index';
	import { getLoRaNotification } from 'src/helpers/addons/addon_lora_helpers';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import type { Device } from 'src/types/Device';

	export let device: Device, statuses;

	$: loRaNotification = getLoRaNotification(device);
</script>

{#if loRaNotification}
	<Alert
		class="mb-s"
		heading={loRaNotification.heading.local}
		type={loRaNotification.type}
		message={loRaNotification.message}
	/>
{/if}
{#each statuses as item}
	{#if $showNewLayout}
		<AdvancedCardV2
			size="m"
			class="mb-s"
			title={item.label}
			avatar={{ icon: item.icon, backgroundColor: 'color-base' }}
		>
			<LabelListV2
				size="m"
				labelList={[
					{
						icon: item.icon,
						value: item.value,
						iconColor: item.iconColor,
					},
				]}
				backgroundColor="--color-base"
				a11yProps={{ isInteractive: true }}
				slot="main"
			/>
		</AdvancedCardV2>
	{:else}
		<AdvancedCard size="m" class="mb-s" title={item.label} avatar={{ icon: item.icon }}>
			<LabelList
				size="m"
				labelList={[
					{
						icon: item.icon,
						value: item.value,
						iconColor: item.iconColor,
					},
				]}
				slot="main"
			/>
		</AdvancedCard>
	{/if}
{/each}
